/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export interface AwardItem {
  id: number
  icon: string
  name: string
}
export interface HistoryRes {
  err_msg?: string
  sum_coins?: number
  // task_coins?: Array<{level: number; coins_reward?: number}>
  task_infos?: Array<{level: number; award_info?: Array<AwardItem>}>
  bonus_pool?: Array<{rank: number; coins_reward: number}>
}

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=96438212
export const rc7_homepage = createAsyncThunk(
  'CrazyRecharge/rc7_homepage',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/rc7_homepage', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=96438277
export const rc7_stage_award = createAsyncThunk(
  'CrazyRecharge/rc7_stage_award',
  async (p: {stage_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        err_msg?: string
        status?: number
      }>
    >('/live/activity/rc7_stage_award', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const rc7_history = createAsyncThunk(
  'CrazyRecharge/rc7_history',
  async (p: {history_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<HistoryRes>>(
      '/live/activity/rc7_history',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data
  }
)

//	领取结果: 0:成功;1: 未完成;2:重复领取
export enum REWARD_STATUS {
  success = 0,
  unDone = 1,
  repeat = 2,
}
// 领取状态 0：未解锁 1：未领取 2：已领取
export enum TASK_STATUS {
  locked = 0,
  available = 1,
  received = 2,
}
export interface IStage {
  id: number
  reward_coins: number
  stage_range: [number, number]
  status: TASK_STATUS
  award_info?: Array<AwardItem>
}

const initialState: {
  recharge_sum?: number
  area_code?: number
  ra_toast?: string
  stages?: Array<IStage>
  show_stage_idx?: number
  explosive_info?: {
    expire_secs: number
    pool_coins: number
    pool_limit: number
    recharge_coins: number
    rank_no: number
    award_coins: number
    rank_award_need: number
  }
  has_explosive?: boolean
  history_stages?: Array<{id: number; time: string}>
  show_history_idx?: number
} = {}

export const CrazyRechargeSlice = createSlice({
  name: 'CrazyRecharge',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(rc7_homepage.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, data)
    })
  },
})

export default CrazyRechargeSlice.reducer
